<div *transloco="let t" class="p-2 mt-6">
  <div class="material-nav">
    <ng-container *ngFor="let product of products; let i = index">
      <div
        class="material"
        (click)="showMaterial(i, product)"
        [class]="{ 'selected-material': i === materialIndex }"
        [style]="{ '--background-color': product.color }"
      >
        <div>
          <p class="mb-0">{{ product.shortTitle }}</p>
        </div>
      </div>
    </ng-container>
  </div>

  <ul
    *ngFor="let downloadMaterials of materials"
    [ngClass]="{ 'show-material': downloadMaterials[0]?.productId === product?.id }"
    [style]="{ '--border-color': product?.color }"
  >
    <app-material-set *ngFor="let material of downloadMaterials; let j = index" [material]="material"></app-material-set>
  </ul>
</div>
